import { FC, useMemo } from "react";
import style from "./alliance-tag.module.css";
import { ALLIANCES } from "~/constants/alliance";
import { useTranslation } from "react-i18next";
import { useCart } from "~/modules/cart/providers/cart.provider";

type AllianceTagProps = {
  allianceName: string;
};

const AllianceTag: FC<AllianceTagProps> = ({ allianceName }) => {
  const { t } = useTranslation();
  const { cartProducts } = useCart();
  const allianceImage = useMemo(() => {
    const alliance = ALLIANCES.find(
      (alliance) => allianceName?.toLowerCase().includes(alliance.allianceName.toLowerCase())
    );
    return alliance?.image || "";
  }, [allianceName]);

  return (
    allianceImage &&
    <div className={`${style.allianceTagContainer} ${cartProducts.length > 0 && style.hasProducts}`}>
        <div className={style.text}>{t("alliance.storeTag")}</div>
        <img src={allianceImage} alt='Payment store' />
      </div>);


};

export default AllianceTag;